import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqs: FAQItem[] = [
  {
    question: 'What is Vigorbuy Spreadsheet?',
    answer: 'Vigorbuy Spreadsheet is a comprehensive product database and buying guide platform that helps shoppers discover, compare, and purchase products across multiple categories including shoes, clothing, accessories, bags, and more. It centralizes product information so you can make informed purchasing decisions without browsing dozens of individual websites.',
  },
  {
    question: 'How does Vigorbuy Spreadsheet work?',
    answer: 'The Vigorbuy Spreadsheet organizes thousands of products into easy-to-navigate categories. Each listing includes key product details, pricing information, and direct links to purchase. Users can browse by category, compare similar products side by side, and access updated information that is refreshed daily to ensure accuracy.',
  },
  {
    question: 'Is Vigorbuy Spreadsheet safe to use?',
    answer: 'Yes, Vigorbuy Spreadsheet is a safe and reliable resource. All product links direct you to the official Kaspreadsheet platform, which follows standard e-commerce security practices. We do not collect personal information or payment details—our platform serves purely as an informational and navigational resource for smart shoppers.',
  },
  {
    question: 'How often is the spreadsheet updated?',
    answer: 'The Vigorbuy Spreadsheet is updated daily to reflect the latest product listings, price changes, and availability. Our team regularly reviews and refreshes the database to ensure you always have access to current and accurate product information.',
  },
  {
    question: 'Can I compare products using Vigorbuy Spreadsheet?',
    answer: 'Absolutely. One of the core benefits of the Vigorbuy Spreadsheet is its comparison capability. You can browse products within the same category, review key specifications, and compare pricing to find the best option for your needs without switching between multiple browser tabs.',
  },
  {
    question: 'Do I need an account to use Vigorbuy Spreadsheet?',
    answer: 'No account is required. The Vigorbuy Spreadsheet is freely accessible to everyone. Simply browse the categories, find products you are interested in, and follow the links to make your purchase on the main platform.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6 py-16 md:py-24">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 text-center mb-3">
          Frequently Asked Questions
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10 md:mb-14">
          Everything you need to know about the Vigorbuy Spreadsheet
        </p>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-lg bg-background-100 border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-200/50 transition-colors"
              >
                <span className="text-sm md:text-base font-semibold text-foreground-950 pr-4">
                  {faq.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-lg text-foreground-500 flex-shrink-0 transition-transform duration-200 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}